import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Openingbalances} from './openingbalances';

@Injectable()
export class OpeningbalancesService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('openingbalances?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('openingbalances/logo').map((response: Response) => response.json());
    }

  getById(_id: string) {
    return this.http.get('openingbalances/' + _id).map((response: Response) => response.json());
  }

  getByYear(_id: string) {
    return this.http.get('openingbalances/showbyyear/' + _id).map((response: Response) => response.json());
  }


  getTrashedById(_id: string) {
        return this.http.get('openingbalances/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('openingbalances/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(invoice: Openingbalances) {
        return this.http.post('openingbalances', invoice).map((response: Response) => response.json());
    }

    update(invoice: Openingbalances) {
        return this.http.put('openingbalances/' + invoice.id, invoice).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('openingbalances/' + _id);
    }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/openingbalances/openingbalances.service.ts